import { EnterNewEmailTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const EnterNewEmailTrackingSchema: Record<
  EnterNewEmailTrackingPoint,
  string
> = {
  [EnterNewEmailTrackingPoint.PageView]: 'eff95531-ca3f-4bdf-81a5-348057549543',
  [EnterNewEmailTrackingPoint.NextButtonClick]:
    '35c48675-15c7-4788-8830-afd4821b7590',
  [EnterNewEmailTrackingPoint.BackButtonClick]:
    '1813665a-2879-4253-8534-966b80cf21b7',
  [EnterNewEmailTrackingPoint.HelpButtonClick]:
    '631364bd-a644-4c3a-a551-e9ab08b81c77',
  [EnterNewEmailTrackingPoint.EnterNewEmailSuccessAction]:
    'e5bbd8f1-0aed-44c3-b216-d19f86d1159f',
  [EnterNewEmailTrackingPoint.EnterNewEmailFailAction]:
    '243bd56a-084f-4161-8d9c-8ffdaae6e831',
};

export const getEnterNewEmailPageTypeAndSchema = (
  trackingPoint: EnterNewEmailTrackingPoint
) => {
  return {
    page_type: PageType.EnterNewEmailPage,
    schema: EnterNewEmailTrackingSchema[trackingPoint],
  };
};
